var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__("popups.CashflowPopupWarning.try_cash_module")
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__default" }, [
              _c(
                "div",
                { staticClass: "cashflow-popup-warning__wrapper" },
                [
                  _c("CompassAlert", {
                    attrs: {
                      type: "warning",
                      description: _vm.content.alert,
                      showIcon: "",
                      action: null,
                      showClose: false
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "typographies-paragraph-medium-regular",
                    domProps: { innerHTML: _vm._s(_vm.content.description) }
                  })
                ],
                1
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.close"),
                    type: "secondary",
                    size: "medium"
                  },
                  on: { click: _vm.close }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.$t.__(
                      "popups.CashflowPopupWarning.contact_support"
                    ),
                    type: "primary",
                    size: "medium",
                    disabled: false
                  },
                  on: {
                    click: function($event) {
                      return _vm.contactSuport()
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }